/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import { App } from './App';
import { createHashRouter, RouterProvider } from 'react-router';
import { Missing } from './components/general/Missing';
import './customising-styling.css';
import { NestedDataForObjectRenderer } from './components/data/NestedDataForObjectRenderer';

let router = createHashRouter([
  {
    path: '/',
    Component: App
  },
  {
    path: '*',
    Component: Missing
  },
  {
    path: '/:collectionName/:id',
    Component: NestedDataForObjectRenderer
  }
]);

function start() {
  const root = createRoot(document.getElementById('root')!);
  root.render(<RouterProvider router={router} />);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
